/**
 * Avalara © 2017
 * file: engines/opus_ui/src/reducers/auth.js
 */

// import jwtDecode from 'jwt-decode';
import { LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS } from '../actions/auth';
import { log } from '../helpers/logger';

const defaultState = {
  isAuthenticated: false,
};

const auth = (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN_USER_SUCCESS:
      // const username = jwtDecode(action.payload.token).username;
      const newState = {
        ...state,
        ...{
          // username,
          // roles: jwtDecode(action.payload.token).roles,
          // token: action.payload.token,
          isAuthenticated: true,
        },
      };
      log('oldWebUI.reducers.auth.userLoggedIn', { state: newState });
      return newState;

    case LOGOUT_USER_SUCCESS:
      return defaultState;

    default:
      return state;
  }
};

export default auth;
